import { vendorHasAnyRequests } from "./myVendorsRequestUtils";
import { sortVendorsByNameAscending } from "./myVendorSortUtils";

/** Phase 2 (Ticket 9) — flip to true to show Document Risk Score filters across My Vendors surfaces. */
export const DOCUMENT_RISK_SCORE_FILTER_ENABLED = false;

/** Phase 2 — flip to true to show Risk Summary on My Vendors tables, lists, cards, and exports. */
export const RISK_SUMMARY_COLUMN_ENABLED = false;

/** Phase 2 — flip to true to show Last Qualified Date on My Vendors tables, lists, cards, and exports. */
export const LAST_QUALIFIED_DATE_COLUMN_ENABLED = false;

export const DOCUMENT_RISK_SCORE_FILTER_OPTIONS = [
  {
    value: "Green",
    label: "Green",
    chipClass: "bg-green-100 text-green-700 ring-green-600/20",
  },
  {
    value: "Yellow",
    label: "Yellow",
    chipClass: "bg-yellow-100 text-yellow-700 ring-yellow-600/20",
  },
  {
    value: "Red",
    label: "Red",
    chipClass: "bg-red-100 text-red-700 ring-red-600/20",
  },
];

export {
  MY_VENDOR_REQUEST_STATUS_BUCKETS,
  MY_VENDOR_LIBRARY_STATUS_BUCKETS,
  hasVendorRiskSummary,
  vendorHasAnyRequests,
} from "./myVendorsRequestUtils";

/**
 * Slim card variant when the vendor has zero entries in BOTH My Requests
 * and Library Requests at render time.
 */
export function isManualOnlyVendor(vendor) {
  return !vendorHasAnyRequests(vendor);
}

/**
 * Same grouping as the Added Manually section: no platform My Requests,
 * including manually-added vendors that only have library documents.
 */
export function isAddedManuallyVendor(vendor) {
  const hasMyRequests = (vendor?.myRequests?.length || 0) > 0;
  return (Boolean(vendor?.isManuallyAdded) && !hasMyRequests) || isManualOnlyVendor(vendor);
}

export function isRequestedInPlatformVendor(vendor) {
  return !isAddedManuallyVendor(vendor);
}

/**
 * UI sections — hidden vendors are grouped separately.
 * Manually-added vendors without sponsor My Requests stay in Added Manually
 * even when library requests exist on the provider profile.
 */
export function splitMyVendorsForDisplay(vendors = []) {
  const hidden = [];
  const requestedInPlatform = [];
  const addedManually = [];
  vendors.forEach((vendor) => {
    if (vendor?.isHidden) {
      hidden.push(vendor);
      return;
    }

    if (isAddedManuallyVendor(vendor)) {
      addedManually.push(vendor);
    } else {
      requestedInPlatform.push(vendor);
    }
  });
  return {
    requestedInPlatform: sortVendorsByNameAscending(requestedInPlatform),
    addedManually: sortVendorsByNameAscending(addedManually),
    hidden: sortVendorsByNameAscending(hidden),
  };
}

export function mergeMyVendorKnownTags(apiTags = []) {
  const merged = new Set(apiTags || []);
  return Array.from(merged).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
}

/**
 * Display label for vendor type. Inserts a zero-width space after "/" so
 * long labels like "Service/Technology Provider" wrap on the slash instead
 * of mid-word inside narrow table columns.
 */
export function getVendorDisplayType(type) {
  const label =
    type === "Service/Technology Vendor"
      ? "Service/Technology Provider"
      : type || "Service/Technology Provider";
  return String(label).replace(/\//g, "/\u200B");
}
